import React from 'react';

const StarFilled = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" fill="white" fill-opacity="0.01" />
    <path
      d="M15.409 1.42156C15.6276 0.895937 16.3722 0.895937 16.5908 1.42156L20.0818 9.81495C20.174 10.0365 20.3824 10.1879 20.6216 10.2071L29.683 10.9336C30.2505 10.9791 30.4805 11.6872 30.0483 12.0576L23.1444 17.9714C22.9622 18.1275 22.8826 18.3725 22.9383 18.606L25.0475 27.4482C25.1796 28.0021 24.5771 28.4398 24.0914 28.1431L16.3335 23.4045C16.1287 23.2795 15.8711 23.2795 15.6663 23.4045L7.90849 28.1431C7.42266 28.4398 6.82027 28.0021 6.95235 27.4482L9.06158 18.606C9.11728 18.3725 9.03766 18.1275 8.85541 17.9714L1.9516 12.0576C1.51926 11.6872 1.74935 10.9791 2.31681 10.9336L11.3782 10.2071C11.6174 10.1879 11.8258 10.0365 11.918 9.81495L15.409 1.42156Z"
      fill="#FF8214"
    />
  </svg>
);

export default StarFilled;
